import $ from "jquery"; // Import jQuery
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import ReactDataTable from "../../../Common/ReactDataTable";
import Select from "react-select";
const CreateSet = () => {
  const navigate = useNavigate();
  const [decorations, setDecorations] = useState([]);
  const [shapes, setShapes] = useState([]); // Store shapes from API
  const { checkRequiredFields } = useRequiredFields();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [itemLoading, setItemLoading] = useState(false); // Loading state for item addition
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [workOrder, setWorkOrder] = useState([]); // Store shape types from API
  const [product, setProduct] = useState([]);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [planningItems, setPlanningItems] = useState([]);
  // const [item, setItem] = useState();
  const [rmpm, setRmpm] = useState([]);
  const [colors, setColors] = useState([
    { id: 1, name: "Blue Glaze" },
    { id: 2, name: "Green Glaze" },
    { id: 3, name: "Red Glaze" },
    { id: 4, name: "White Glaze" },
    { id: 5, name: "Black Glaze" },
    { id: 6, name: "Yellow Glaze" },
    { id: 7, name: "Purple Glaze" },
    { id: 8, name: "Brown Glaze" },
  ]);
  useEffect(() => {
    fetchInitialData();
    $("body").addClass("collapse-menu");
    $("body").toggleClass("show-left");
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const resPlanning = await Http.get(
        "/planning?production=1&returnOnlyItems=1"
      );

      Http.get("/gless-colour").then((res) => {
        setColors(res.data);
      });

      const planningData = resPlanning.data;
      setPlanningOptions(planningData);

      Http.get("/planning-image").then((res) => {
        setDecorations(res.data);
      });

      // const resProduct = await Http.get(`/product-list/all`);

      const order = await Http.get("/production-work-order"); // Fetch shape data from API
      setWorkOrder(order.data);

      const resInvoiceNo = await Http.get(
        "/last-code-increment-by-one/sets/code/ST"
      );

      const response = await Http.get("/shape"); // Fetch shape data from API
      const data = response.data;
      setShapes(data);

      setInputs((values) => ({
        ...values,
        code: resInvoiceNo.data,
      }));
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const addMoreList = async (item) => {
    setItemLoading(true); // Use itemLoading to control this specific action
    console.log(item, "item");
    try {
      let response = await Http.get(`/get-product/${item?.id}`);
      response.data.production_work_order_item_id = item?.id;
      response.data.shape_id = item?.shape?.id;

      // Check if product already exists in list
      const productExists = list.some(
        (item) => item.production_work_order_item_id === response.data.id
      );

      if (productExists) {
        Swal.fire({
          icon: "warning",
          title: "Product Already Added",
          text: "This product is already in the list",
        });
        return;
      }

      setList((prev) => [...prev, response.data]);
    } catch (error) {
      console.error("Error fetching product:", error);
      Swal.fire("Error!", "Failed to add product.", "error");
    } finally {
      setItemLoading(false); // Stop loading after action is complete
    }
  };
  console.log(list, "list");
  const removeList = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedList = list.filter((_, i) => i !== index);
        setList(updatedList);
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));

    if (name === "work_order_id") {
      const resProduct = await Http.get(
        `/get-product-work-order-wise/` + value
      );
      setProduct(resProduct.data.items);
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const inputInfo = [...list];

    if (name === "decoration_code") {
      // Find the selected decoration
      const selectedDecoration = decorations.find(
        (dec) => dec.id.toString() === value
      );

      // Update both decoration_code and decoration_name
      inputInfo[index] = {
        ...inputInfo[index],
        decoration_code: value,
        decoration_name: selectedDecoration
          ? selectedDecoration.decoration_name
          : inputInfo[index].decoration_name,
      };
    } else {
      inputInfo[index][name] = value;
    }

    setList(inputInfo);
  };

  const formSubmit = (e) => {
    e.preventDefault();
    const isValid = checkRequiredFields();
    inputs.items = list;
    const updatedList = list.map((item) => ({
      ...item,
      product_id: item.product_id,
    }));

    // Assign the updated list to inputs.items
    inputs.items = updatedList;
    Http.post("/sets", inputs)
      .then((res) => {
        navigate("/sets", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors);
      });
  };

  const cols = [
    { field: "product.code", header: "Code" },
    { field: "product.name", header: "Item" },
    { field: "shape.name", header: "Shape" },
    { field: "decoration.code", header: "DEC Code" },
    { field: "decoration_name", header: "Decoration Name" },
    { field: "color.colour_name", header: "Color" },
  ];
  const actionTemplate = (item, deleteData) => {
    return (
      <td className="text-right">
        <button
          className="btn btn-success btn-sm"
          onClick={() => addMoreList(item)}
        >
          <i className="fa fa-plus"></i>
        </button>
      </td>
    );
  };

  const handlePlanningChange = async (planningId) => {
    if (!planningId) return;

    setList([]);
    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId, // Update planning_id in inputs
    }));

    try {
      // Fetch data based on selected planning ID
      const response = await Http.get(
        `/planning/${planningId}?production=1&returnOnlyItems=1`
      );
      setRmpm(response.data);
      setList(planningItems);
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error"
      );
    }
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Set</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-8">
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Create Set
            </h6>
            <hr></hr>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label>
                      Receipt no <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      disabled
                      value={inputs.code || ""}
                      onChange={handleChange}
                      placeholder="Input Date"
                      data-required
                    />

                    {/* {displayError("work_order_date")} */}
                  </div>
                  <div className="col-lg">
                    <label>
                      Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      defaultValue={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Name"
                      data-required
                    />

                    {/* {displayError("receipt_no")} */}
                  </div>
                </div>
                <div className="row mt-2">
                  {/* <div className="col-lg">
                                        <label>Planning</label>
                                        <select
                                            className="form-control"
                                            name="planning_id"
                                            value={inputs.planning_id || ""} // Bind to inputs
                                            onChange={(e) => handlePlanningChange(e.target.value)}
                                        >
                                            <option value="">Select Planning</option>
                                            {planningOptions.map((planning) => (
                                                <option key={planning.id} value={planning.id}>
                                                    {planning.receipt_no}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}
                  <div className="col-lg">
                    <label>Work Order</label>{" "}
                    <i className="fa fa-star required"></i>
                    <select
                      className="form-control"
                      name="work_order_id"
                      defaultValue={inputs.work_order_id || ""}
                      onChange={handleChange}
                      data-required
                    >
                      <option value="">Select Work Order</option>
                      {workOrder?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.receipt_no}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* <div className="col-lg">
                    <label>
                      Department <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="department_art_id"
                      defaultValue={inputs.department_art_id || ""}
                      onChange={handleChange}
                      data-required
                    >
                      <option value="" disabled selected>
                        Select Department
                      </option>
                      <option value="12">Packing Local</option>
                      <option value="13">Packing Export</option>
                    </select>
                  </div> */}
                </div>

                <div className="row mt-3">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Set Items <i className="fa fa-star required"></i>
                      </h5>
                    </div>
                    <div className="card-body p-0">
                      <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              #
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Product
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Shape <i className="fa fa-star required"></i>
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Decoration Code
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Decoration Name
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              Glaze Color
                            </th>
                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                              QTY <i className="fa fa-star required"></i>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {list.length < 1 ? (
                            <tr>
                              <td colSpan={12}>
                                <p
                                  style={{ color: "red" }}
                                  className="text-center mt-3"
                                >
                                  Please Add Few Products For Work Order
                                </p>
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}

                          {Array.from(list).map((x, i) => (
                            <tr key={i}>
                              <td>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeList(i)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </td>

                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="product"
                                  defaultValue={list[i].product.name}
                                  onChange={handleChange}
                                  placeholder="Product"
                                  disabled
                                />
                              </td>
                              <td>{x.shape.name}</td>

                              <td>{x?.decoration?.code}</td>
                              <td>{x?.decoration_name}</td>
                              <td>{x?.color?.colour_name}</td>

                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="qty"
                                  placeholder="Qty"
                                  //   defaultValue={list[i].qty}
                                  onChange={(e) => {
                                    const updatedList = [...list];
                                    updatedList[i].qty = e.target.value;
                                    setList(updatedList);
                                  }}
                                  data-required
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="card pd-20 pd-sm-40 col-3"
            style={{ backgroundColor: "#ffffffc7" }}
          >
            <h6 className="card-body-title mg-sm-b-30 text-center">
              Available Items
            </h6>
            <hr></hr>
            <ReactDataTable
              cols={cols}
              receiveData={product}
              isLoading={loading}
              actionTemplate={actionTemplate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSet;
